import type { SiteSettings } from '@common/types/site.type';
import type { SettingsState } from './settings.reducer';
import { WEBSITE_SETTINGS_FEATURE_KEY } from './settings.reducer';
import type { WebsiteState } from '../website-feature.reducer';

import { createSelector } from '@ngrx/store';
import { selectIsAdmin } from '@web/store/app/app.selectors';
import { websiteState } from '../website-state.selectors';

export const selectSettingsState = createSelector(
    websiteState,
    (state: WebsiteState): SettingsState => state[WEBSITE_SETTINGS_FEATURE_KEY]
);

export const selectSiteSettings = createSelector(
    selectSettingsState,
    (state: SettingsState): SiteSettings => state?.settings
);
export const selectShowPoweredBy = createSelector(selectSiteSettings, (siteSettings: SiteSettings) =>
    Boolean(Number(siteSettings?.is_show_sp_logo ?? '1'))
);
export const selectIsPage404 = (pageId: number | string) =>
    createSelector(selectSiteSettings, selectIsAdmin, (siteSettings: SiteSettings, isAdmin: boolean): boolean =>
        isAdmin ? false : siteSettings?.not_found_page_id?.toString() === pageId?.toString()
    );

export const selectShopSettings = createSelector(
    selectSettingsState,
    (state: SettingsState): SiteSettings['shop'] => state?.settings?.shop
);
export const selectShopSettingsCurrency = createSelector(
    selectSettingsState,
    (state: SettingsState): SiteSettings['shop']['currency'] => state?.settings?.shop?.currency
);
export const selectMainPageId = createSelector(
    selectSettingsState,
    (state: SettingsState): SiteSettings['main_page_id'] => state?.settings?.main_page_id
);
